export interface DeviceMigrationRequest {
	/**
	 * The user code, used by the wizard to pair/create a new device.
	 */
	userCode: string;
	/**
	 * The pairing (wizard) URL.
	 */
	newUrl: string;
	/**
	 * The old URL for parsing kvps.
	 */
	oldUrl: string;
}

export interface ExchangeDeviceCodeResponse {
	/**
	 * Token used for authorization refresh.
	 */
	refresh_token: string;
	/**
	 * Token identifying the device.
	 */
	id_token: string;
	/**
	 * Authorization token type.
	 */
	token_type: string;
}

export interface GetDeviceCodeResponse {
	device_code: string;
	user_code: string;
	verification_uri: string;
	verification_uri_complete: string;
	expires_in: number;
	interval: number;
}

/**
 * Requests a device code for pairing.
 * @param pairingUrl The pairing (wizard) URL where the device will be created.
 * @returns Resolves with the device code and data about its expiration.
 */
export const requestDeviceCode = async (
	pairingUrl: string
): Promise<GetDeviceCodeResponse> => {
	const url = `${pairingUrl}/oauth/device/code`;
	const response = await fetch(url, {
		method: 'POST',
		headers: { 'X-Requested-With': 'XMLHttpRequest' },
	});
	return response.json();
};

const params = new URLSearchParams(window.location.search);
let account: { [key: string]: string | null } = {};
if (params.get('apk') === 'true') {
	// read account.ini from url
	params
		.get('account')
		?.split('\n')
		.forEach(line => {
			line = line.trim();
			if (!line || line.startsWith(';')) return;
			let [key, value] = line.includes('=')
				? line.split('=')
				: [line, null];
			account[key] = value?.trim() || null;
		});

	console.log(account.id);
}

/**
 * Triggers the migration of an old "terminals" device to a new delivery device.
 * @param options The options.
 * @returns Resolves with an "exchange device code" response, just like after pairing a new device.
 */
export const migrateDevice = async (
	options: DeviceMigrationRequest
): Promise<ExchangeDeviceCodeResponse> => {
	const url = `${options.newUrl}/module/didMultiBrand/bpca/api/dealer/devices/activate?LegacyDeviceId=${account.id}&UserCode=${options.userCode}`;
	const match = options.oldUrl.match(/([A-Z]{3}\d{5})/i);

	let suffix = options.oldUrl.includes('audi') ? 'A' : 'V';
	let userKvps = match ? match[1].toUpperCase() + suffix : '';
	let response = await fetch(url, {
		method: 'POST',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
			'Did-User-Kvps': userKvps,
		},
	});

	if (!options.oldUrl.includes('audi') && !response.ok && match) {
		userKvps = match[1] + 'N';
		response = await fetch(url, {
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Did-User-Kvps': userKvps,
			},
		});
	}

	if (!response?.ok) {
		throw new Error(
			`Error while trying to migrate device: ${response?.status} ${response?.body}`
		);
	}

	return response.json();
};
